import { Component, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { FactoryService } from '@dotgov/core';
import { Subject } from 'rxjs/internal/Subject';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Widgets } from '../../../models/widgets';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'interface-widget-list',
  template: `<div class="container">
  <h5 class="pt-2">Add Widget</h5>
  <div class="input-group">
    <input [(ngModel)]="searchText" class="form-control py-2 border-right-0 border" type="search" placeholder="Search for widgets here">
  </div>
</div>
<hr class="mb-0">
<div class="widget">
  <div #container></div>
</div>`,
  styles: [`:host{min-width:350px;width:350px;max-width:350px;float:right;background-color:#fff;border-left:1px solid #ccc}.widget{position:relative}`],
})
export class ListComponent implements AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) container;
  private searchTextSubject = new Subject<string>();
  private _searchText: string;
  private _widgets: any[] = [...Widgets];

  constructor(private _factory: FactoryService) {
    this.searchTextSubject.pipe(distinctUntilChanged()).pipe(debounceTime(450)).subscribe((searchText) => {
      this.renderList(searchText);
    });
  }

  ngAfterViewInit() {
    this.renderList();
  }

  get searchText() {
    return this._searchText;
  }

  set searchText(text: string) {
    this._searchText = text;
    this.searchTextSubject.next(text);
  }

  get widgets() {
    return this._widgets;
  }

  private renderList(searchText?: string) {
    this.container.clear();
    let widgetList = this.widgets;
    if (searchText) {
      widgetList = widgetList.filter((w) => `${w.TITLE} ${w.DESCRIPTION}`.indexOf(searchText) !== -1);
    }
    widgetList.forEach(w => {
      this._factory.componentByName(w.name, this.container, { preview: true });
    });
  }
}
